import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e7c6baf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tir-pm-video-player-controls" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "tir-pm-video-player-controls_edit" }
const _hoisted_4 = { class: "tir-pm-video-player-controls_edit_buttons" }

import { PlayIcon, PauseIcon } from 'tir-style-system/icons/solid'
import {
  PencilSquareIcon,
  ArrowDownTrayIcon,
  ArrowsPointingOutIcon,
  ArrowsPointingInIcon,
} from 'tir-style-system/icons/solid'
import { PopoverPositionEnum, TirPmPopover } from 'tir-pm-popover'
import { TirPmInput } from 'tir-pm-input'
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
} from 'tir-pm-button'
import { computed, onBeforeMount, ref, watch } from 'vue'

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'tir-pm-video-player-controls',
  props: {
  /**Текущее время просмотра */
  currentTime: { type: Number },
  /**Время видео */
  duration: { type: Number },
  /**Проигрывается ли видео */
  play: { type: Boolean },
  /**Активен полноэкранный режим */
  fullscreen: { type: Boolean },
  /**Имя видеозаписи */
  name: { type: String },
},
  emits: ["update:play", "update:fullscreen", "edit", "download", "popover", "updateName"],
  setup(__props, { emit }) {

const props = __props;


/**События */

const nameWithoutExtension = computed(() => props.name && removeFileExtension(props.name))
/**Локальное имя файла */
const innerName = ref('')
/**Поповер с формой редактирования имени */
const $namePopover = ref<InstanceType<typeof TirPmPopover>>()

/**Время проигрывания */
const time = computed(() => {
  const currentTime = Number((props.currentTime || 0).toFixed(0))
  const duration = Number((props.duration || 0).toFixed(0))

  return `${getParsedTime(currentTime)} / ${getParsedTime(duration)}`
})

/**Отслеживание изменений имени файла */
watch(() => props.name, setName)

/**Перед рендером */
onBeforeMount(() => setName())

const removeFileExtension = (fileName: string): string => {
  const lastDotIndex = fileName.lastIndexOf(".");
  if (lastDotIndex === -1) return fileName; // Если точки нет, возвращаем исходное имя
  return fileName.substring(0, lastDotIndex);
};

/**Установка значения поля innerName */
function setName() {
  innerName.value = removeFileExtension(props.name || '');
}
/**Получить время в формате 01:01:01 */
const getParsedTime = (d: number) => {
  const hours = upScaleLength(Math.floor(d / 3600))
  const minutes = upScaleLength(Math.floor((d % 3600) / 60))
  const seconds = upScaleLength(Math.floor((d % 3600) % 60))
  return `${hours}:${minutes}:${seconds}`
}

/**Переключение пригрывания */
const togglePlay = () => {
  emit('update:play', !props.play)
}
/**Переключение полноэкранного режима */
const toggleFullscreen = () => {
  emit('update:fullscreen', !props.fullscreen)
}
/**Скачать видео */
const download = () => {
  emit('download')
}
/**Добавление "0" для таймера */
const upScaleLength = (_seconds: number) => {
  const seconds = _seconds.toString()
  return seconds.length < 2 ? '0' + seconds : seconds
}
/**Отслеживание видимости поповера */
const togglePopover = (isOpen: boolean) => {
  emit('popover', isOpen)
}
/**Закрыть поповер с редактированием имени */
const closePopover = () => {
  $namePopover.value?.close()
}
/**Сохранение имени поповера */
const saveName = () => {
  emit('updateName', innerName.value)
  closePopover()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      textContent: _toDisplayString(time.value),
      class: "tir-pm-video-player-controls_time"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", {
      class: "tir-pm-video-player-controls_button middle",
      onClick: togglePlay
    }, [
      (__props.play)
        ? (_openBlock(), _createBlock(_unref(PauseIcon), { key: 0 }))
        : (_openBlock(), _createBlock(_unref(PlayIcon), { key: 1 }))
    ]),
    _createVNode(_unref(TirPmPopover), {
      ref_key: "$namePopover",
      ref: $namePopover,
      width: "25rem",
      position: _unref(PopoverPositionEnum).Top,
      onOpen: _cache[2] || (_cache[2] = ($event: any) => (togglePopover(true))),
      onClose: _cache[3] || (_cache[3] = ($event: any) => (togglePopover(false)))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "tir-pm-video-player-controls_button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('edit')))
        }, [
          _createVNode(_unref(PencilSquareIcon))
        ])
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(TirPmInput), {
            modelValue: innerName.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((innerName).value = $event)),
            "is-small-size": "",
            "auto-focus": "",
            label: "Название файла",
            "is-with-hint": false,
            onEnter: saveName
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(TirPmButton), {
              variant: _unref(TirPmButtonVariantEnum).PrimaryState,
              size: _unref(TirPmButtonSizeEnum).Small,
              "is-disabled": nameWithoutExtension.value == innerName.value,
              onClick: saveName
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Сохранить ")
              ]),
              _: 1
            }, 8, ["variant", "size", "is-disabled"]),
            _createVNode(_unref(TirPmButton), {
              variant: _unref(TirPmButtonVariantEnum).SecondaryState,
              size: _unref(TirPmButtonSizeEnum).Small,
              onClick: closePopover
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Отмена ")
              ]),
              _: 1
            }, 8, ["variant", "size"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["position"]),
    _createElementVNode("div", {
      class: "tir-pm-video-player-controls_button",
      onClick: download
    }, [
      _createVNode(_unref(ArrowDownTrayIcon))
    ]),
    _createElementVNode("div", {
      class: "tir-pm-video-player-controls_button",
      onClick: toggleFullscreen
    }, [
      (__props.fullscreen)
        ? (_openBlock(), _createBlock(_unref(ArrowsPointingInIcon), { key: 0 }))
        : (_openBlock(), _createBlock(_unref(ArrowsPointingOutIcon), { key: 1 }))
    ])
  ]))
}
}

})